/* eslint-disable no-restricted-imports */
import React, { useEffect, useMemo } from "react";
import { Modal } from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { ModalProgressBar } from "../../../../../../_metronic/_partials/controls";
import * as actions from "../../../_redux/states/statesActions";
import { useStatesUIContext } from "../StatesUIContext";

export function StatesDeleteDialog({ show, onHide }) {
  // States UI Context
  const statesUIContext = useStatesUIContext();
  const statesUIProps = useMemo(() => {
    return {
      ids: statesUIContext.ids,
      setIds: statesUIContext.setIds,
      queryParams: statesUIContext.queryParams,
    };
  }, [statesUIContext]);

  // States Redux state
  const dispatch = useDispatch();
  const { isLoading } = useSelector(
    (state) => ({ isLoading: state.states.actionsLoading }),
    shallowEqual
  );

  // looking for loading/dispatch
  useEffect(() => {}, [isLoading, dispatch]);

  // if there weren't selected states we should close modal
  useEffect(() => {
    if (!statesUIProps.ids || statesUIProps.ids.length === 0) {
      onHide();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statesUIProps.ids]);

  const deleteStates = () => {
    // server request for deleting state by selected ids
    dispatch(actions.deleteStates(statesUIProps.ids)).then(() => {
      // refresh list after deletion
      dispatch(actions.fetchStates(statesUIProps.queryParams)).then(() => {
        // clear selections list
        statesUIProps.setIds([]);
        // closing delete modal
        onHide();
      });
    });
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      aria-labelledby="delete-states-modal-title"
    >
      {isLoading && <ModalProgressBar />}
      <Modal.Header closeButton className="py-4 px-6">
        <Modal.Title id="delete-states-modal-title" className="font-weight-bolder text-dark">
          Delete Selected States
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="py-4 px-6">
        <div className="d-flex align-items-center">
          <div className="mr-4">
            <span className="label label-xl label-light-danger label-inline p-4" style={{ borderRadius: "50%" }}>
              <i className="fa fa-exclamation-triangle text-danger font-size-h4"></i>
            </span>
          </div>
          <div>
            <h6 className="font-weight-bolder text-dark mb-1">Confirm Deletion</h6>
            <p className="text-muted mb-0 font-size-sm">
              Are you sure you want to permanently delete{" "}
              <strong className="text-danger font-weight-bolder">
                {statesUIProps.ids.length} selected states
              </strong>
              ? This action cannot be undone.
            </p>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="py-3 px-6">
        <button
          type="button"
          onClick={onHide}
          className="btn btn-light font-weight-bold"
          disabled={isLoading}
        >
          Cancel
        </button>
        <button
          type="button"
          onClick={deleteStates}
          className="btn btn-danger font-weight-bold"
          disabled={isLoading}
        >
          {isLoading ? (
            <>
              <i className="fa fa-circle-notch fa-spin mr-1"></i> Deleting...
            </>
          ) : (
            "Delete States"
          )}
        </button>
      </Modal.Footer>
    </Modal>
  );
}
